<template>
  <div class="card-body text-center">
    <h5 class="card-title">
      <a :href="linkToTicket" target="_blank">
        PEDIDO
        <span class="custom_hover">{{ hideId }}</span>
        <span>{{ customId }}</span>
      </a>
    </h5>
    <span>pedido {{ productSale.created_at | relativeTime }}</span>
    <span v-if="productSale.maked_at"
      >, realizado {{ productSale.maked_at | relativeTime }}
    </span>
    <div class="mt-2">
      <span
        class="fa-stack fa-1x i_size"
        v-show="productSale.type_id == 1"
        title="Para la mesa"
      >
        <i class="fas fa-circle fa-stack-2x"></i>
        <i class="fas fa-utensils fa-stack-1x fa-inverse"></i>
      </span>
      <span
        class="fa-stack fa-1x i_size"
        v-show="productSale.type_id != 1"
        title="Para llevar"
      >
        <i class="fas fa-circle fa-stack-2x"></i>
        <i class="fas fa-shopping-bag fa-stack-1x fa-inverse"></i>
      </span>
      <span
        class="fa-stack fa-1x i_size"
        v-show="productSale.type_id == 3"
        title="Para delivery"
      >
        <i class="fas fa-circle fa-stack-2x"></i>
        <i class="fas fa-motorcycle fa-stack-1x fa-inverse"></i>
      </span>
      <span
        class="fa-stack fa-1x i_size"
        v-show="productSale.total_on_sale > 1"
        title="Incluye varios productos"
      >
        <i class="fas fa-circle fa-stack-2x"></i>
        <i class="fas fa-list fa-stack-1x fa-inverse"></i>
      </span>
    </div>
  </div>
</template>
<script>
import { ticketLinkFactory } from "./ticketLinkFactory.js";

export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    productSale: {
      default: () => ({
        sale_id: 0,
        created_at: "",
        maked_at: "",
        type_id: 0
      })
    }
  },

  data: () => ({
    //
  }),

  computed: {
    linkToTicket() {
      return ticketLinkFactory(this.productSale.sale_id);
    },
    hideId() {
      if (!this.productSale.sale_id) return "";
      var idInString = this.productSale.sale_id.toString();
      return idInString.slice(0, idInString.length - 3);
    },
    customId() {
      if (!this.productSale.sale_id) return "";
      var idInString = this.productSale.sale_id.toString();
      return idInString.slice(idInString.length - 3, idInString.length);
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  }
};
</script>

<style scoped>
.custom_hover {
  color: white;
  background-color: black;
}

.i_size {
  font-size: 1.3rem;
}

.app_i_box {
  font-size: 0.6em;
  color: red;
}
</style>
